/**
 * Centralized deep-link builders. Add new routes here so callers don't
 * hand-construct URL strings that drift when the URL contract changes.
 */
export const routes = {
  resumeChat: (sessionId: string, workspaceId?: string | null): string => {
    const params = new URLSearchParams({ resumeSession: sessionId });
    if (workspaceId) params.set('w', workspaceId);
    return `/?${params.toString()}`;
  },
  plan: (planId: string): string => `/projects/${planId}`,
  document: (messageId: string): string => `/documents?id=${encodeURIComponent(messageId)}`,
};
